module.exports = __webpack_public_path__ + "img/Paso 27.91d0a480.png";